<template>
  <div class="supermarket-container">
    <TopBar :imgsrc="logo1"/>
    <div class="Bigimg">
      <p class="imgtitle">数循数据集超市</p>
      <p class="imgcontent">找数据,来这里</p>
    </div>
    <div class="introduce">
      <p class="title">什么是数据集超市?</p>
      <p class="content">数循数据集超市，是为数据资源提供价值流通的平台，是面向即弃、闲置数据的数商平台(数据集淘宝)</p>
      <router-link to="/Dataset" class="look">查看数据集</router-link>
    </div>
    <Serve/>
  </div>
</template>

<script>
import logo1 from "@/assets1/首页_slices (1)/编组 2.png"
import TopBar from "./TopBar"
import Serve from "./Serve"
export default {
components:{
    TopBar,Serve
},data(){
  return{
    logo1
  }
}
}
</script>

<style scoped>
.imgcontent{
  font-size: 24px;
  font-family: Regular;
  line-height: 46px;
}
.imgtitle{
  font-size: 48px;
  font-family: Heavy;
  line-height: 65px;
  margin-bottom: 17px;
}
.look{
  width: 200px;
  height: 56px;
  line-height: 56px;
  text-align: center;
  background-color: #0D53FF;
  border-radius: 12px;
  color: #fff;
  font-family: Regular;
  letter-spacing: 0.5px;
}
.title{
  margin-top: 100px;

  font-size: 36px;
  font-family: Medium;
  margin-bottom: 30px;
}
.content{
  width: 1200px;

  font-family: Regular;
  font-size: 18px;
  line-height: 25px;
  margin-bottom: 60px;
  text-align: center;
}
.supermarket-container{

  position: relative;
}
.Bigimg{
  min-width: 1920px;
  height: 500px;
  background-image: url('https://sxoffcia.oss-cn-chengdu.aliyuncs.com/offcia_Img/%E6%95%B0%E6%8D%AE%E9%9B%86%E8%B6%85%E5%B8%82%E4%BB%8B%E7%BB%8D%E9%A1%B5/%E5%85%B3%E4%BA%8E%E6%88%91%E4%BB%ACbanner%E6%9C%80%E7%BB%88%E7%89%88.png');
  text-align: center;
 background-size: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
}
.introduce{
  min-width: 1920px;
  height: 450px;
  display: flex;
  flex-direction: column;
    align-items: center;
      background-image: url('https://sxoffcia.oss-cn-chengdu.aliyuncs.com/offcia_Img/%E6%95%B0%E6%8D%AE%E9%9B%86%E8%B6%85%E5%B8%82%E4%BB%8B%E7%BB%8D%E9%A1%B5/%E4%BD%8D%E5%9B%BE.png');
      color: #fff;
       background-size: 100%;
}
</style>